/* ============================================================
   ECADRA — Search JS (المرحلة 2)
   فتح درج البحث من أيقونات الهيدر + predictive search فوري
   ============================================================ */
(function () {
  'use strict';
  var drawer = document.getElementById('SearchDrawer');
  if (!drawer) return;
  var E = window.ECADRA || {};
  var input = drawer.querySelector('[data-search-input]');
  var results = drawer.querySelector('[data-predictive-results]');
  var searchUrl = (E.routes && E.routes.search) || '/search';

  /* اعتراض أيقونات البحث في الهيدر — تفتح الدرج بدل صفحة البحث */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="' + searchUrl + '"]');
    if (!link || !link.closest('.e-header-wrap')) return;
    e.preventDefault();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 80);
  });

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('e-search__overlay')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* الـ predictive search */
  var debounce, controller;
  function fetchResults(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = searchUrl + '/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&section_id=search-drawer';
    drawer.classList.add('is-searching');
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-predictive-results]');
        if (fresh && results) results.innerHTML = fresh.innerHTML;
        var all = results.querySelector('[data-search-all]');
        if (all) all.href = searchUrl + '?q=' + encodeURIComponent(q);
      })
      .catch(function (err) { if (err.name !== 'AbortError') console.warn(err); })
      .finally(function () { drawer.classList.remove('is-searching'); });
  }

  if (input) input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounce);
    if (q.length < 2) { if (results) results.innerHTML = ''; return; }
    debounce = setTimeout(function () { fetchResults(q); }, 250);
  });
})();